import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

const labelCss = css({
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "20px"
});

export const Label = ({ children }: PropsWithChildren) => {
    return <span css={labelCss}>{children}</span>;
};
